import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import styles from './PostCreatedPage.module.css';

const PostCreatedPage = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { postId, title } = location.state || {};


    // Фразы для праздничного сообщения
    const celebrations = [
        "🎉 Ура! Пост создан!",
        "🚀 Запускаем в космос вашу гениальную мысль!",
        "📝 Еще один шедевр добавлен в коллекцию!",
        "💡 Идея успешно материализована!",
        "☕ Кофе может гордиться - он не зря потрачен!"
    ];

    const randomCelebration = celebrations[Math.floor(Math.random() * celebrations.length)];

    return (
        <div className={styles.postCreatedPage}>
            <div className={styles.container}>
                <div className={styles.successAnimation}>
                    <div className={styles.checkmark}>✓</div>
                    <div className={styles.confetti}></div>
                    <div className={styles.confetti}></div>
                    <div className={styles.confetti}></div>
                    <div className={styles.confetti}></div>
                    <div className={styles.confetti}></div>
                </div>

                <h1 className={styles.title}>{randomCelebration}</h1>

                <div className={styles.postInfo}>
                    <h2>Информация о посте:</h2>
                    <p><strong>ID:</strong> #{postId || "засекречено"} <span className={styles.note}>(запомните, вдруг пригодится!)</span></p>
                    <p><strong>Название:</strong> {title || "Безымянный шедевр"}</p>
                    <p className={styles.status}><strong>Статус:</strong> Гениально ✅</p>
                </div>

                <div className={styles.nextSteps}>
                    <h3>Что дальше? 🤔</h3>
                    <div className={styles.options}>
                        <div className={styles.optionCard}>
                            <span className={styles.emoji}>✏️</span>
                            <h4>Написать еще один пост</h4>
                            <p>Вдохновение еще не закончилось?</p>
                            <button
                                onClick={() => navigate('/create_post')}
                                className={styles.optionButton}
                            >
                                Создать новый
                            </button>
                        </div>

                        <div className={styles.optionCard}>
                            <span className={styles.emoji}>👀</span>
                            <h4>Посмотреть свой пост</h4>
                            <p>Полюбоваться на результат</p>
                            <button
                                onClick={() => navigate(`/post/${postId}`)}
                                className={styles.optionButton}
                                disabled={!postId}
                            >
                                {postId ? 'Перейти к посту' : 'Скоро будет доступно'}
                            </button>
                        </div>

                        <div className={styles.optionCard}>
                            <span className={styles.emoji}>🏠</span>
                            <h4>Вернуться на главную</h4>
                            <p>К другим интересным постам</p>
                            <button
                                onClick={() => navigate('/')}
                                className={styles.optionButton}
                            >
                                На главную
                            </button>
                        </div>
                    </div>
                </div>

                <div className={styles.funSection}>
                    <h3>Пока пост публикуется... 🎪</h3>
                    <div className={styles.funFacts}>
                        <p>Знаете ли вы? Этот пост обрабатывается нашими сверхсекретными алгоритмами,
                            которые проверяют его на наличие:</p>
                        <ul>
                            <li>☕ Упоминаний кофе (очень важно!)</li>
                            <li>😅 Опечаток в коде</li>
                            <li>🎨 Достаточного количества эмодзи</li>
                            <li>💡 Гениальных идей (хотя бы одна должна быть)</li>
                        </ul>
                    </div>
                </div>

                <div className={styles.coffeeInvite}>
                    <p>Пока ждете — можете выпить кофе! ☕</p>
                    <small>Наши серверы работают на кофеине, поэтому мы понимаем друг друга</small>
                </div>
            </div>
        </div>
    );
};

export default PostCreatedPage;